export const WORDS = [
  'champ',
]
